import { categories } from "../data/categories.js";
import CategoryCard from "../components/CategoryCard.js";

const ProductsPage = () => (
  <main className="min-h-screen bg-slate-50">
    <section className="bg-containx-navy px-6 py-14 text-center text-white md:py-20">
      <p className="mb-3 text-sm font-bold uppercase tracking-widest text-containx-beige">Restaurant & food-service supplies</p>
      <h1 className="mb-4 text-4xl font-bold md:text-5xl">Find the right product</h1>
      <p className="mx-auto max-w-2xl text-lg text-slate-200">Browse dependable packaging, bags, and everyday supplies for your operation.</p>
    </section>
    <div className="mx-auto max-w-6xl px-6 py-12 md:py-16">
      <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((category) => <CategoryCard key={category.slug} category={category} />)}
      </div>
      <div className="mt-12 flex flex-col items-center justify-between gap-5 rounded-2xl bg-containx-beige p-6 text-containx-navy md:flex-row md:p-8">
        <div><h2 className="text-2xl font-semibold">Prefer the complete catalog?</h2><p className="mt-1">See every available SKU in one downloadable document.</p></div>
        <a href="/pdf/product-catalog.pdf" target="_blank" rel="noopener noreferrer" className="shrink-0 rounded-lg bg-containx-navy px-6 py-3 font-semibold text-white transition hover:bg-containx-charcoal">View Full Catalog</a>
      </div>
    </div>
  </main>
);

export default ProductsPage;
